/* DO NOT MODIFY. This is an autogenerated file. */
/* eslint-disable */
import * as React from "react"
import type { SVGProps } from "react"

export const SvgUserProfile = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || "100%"}
    height={props.height || "100%"}
    fill="none"
    viewBox="0 0 24 24"
    data-name="SvgUserProfile"
    {...props}
  >
    {props.children}
    <path
      fill="#404257"
      d="M24 12a11.96 11.96 0 0 1-4.207 9.125q-.573.49-1.204.906A11.94 11.94 0 0 1 12 24a11.94 11.94 0 0 1-8.399-3.43A11.96 11.96 0 0 1 0 12C0 5.372 5.372 0 12 0s12 5.372 12 12"
    />
    <path
      fill="#2B2D42"
      d="M20.399 20.57a12 12 0 0 1-1.81 1.461A11.94 11.94 0 0 1 12 24a11.94 11.94 0 0 1-8.399-3.43 4.68 4.68 0 0 1 3.006-2.909l3.588-1.133v-.592c-.448-.264-.852-.567-1.184-.795a2.7 2.7 0 0 1-1.152-1.801l-.191-1.144c-.6 0-1.083-.484-1.083-1.083V8.585A5.41 5.41 0 0 1 12 3.17a5.417 5.417 0 0 1 5.415 5.415v2.528c0 .599-.484 1.083-1.083 1.083l-.191 1.144a2.7 2.7 0 0 1-1.155 1.801c-.333.224-.73.53-1.18.795v.592l3.584 1.133a4.68 4.68 0 0 1 3.009 2.91"
      opacity={0.5}
    />
  </svg>
)
